<template>
    <span>
        <slot
            v-bind="{
                ...$data,
                methods: {
                    getPlayers,
                },
            }"
        />
    </span>
</template>

<script>
import {
    mapState,
    mapActions,
} from 'vuex';

export default {
    props: {
        itemsLimit: {
            type: Number,
            required: true,
        },
        apiUrls: {
            type: Object,
            required: true,
        },
        itemsType: {
            type: String,
            required: true,
        },
    },

    data: () => ({
        players: [],
        formLoading: false,
        playersError: false,
    }),

    computed: {
        ...mapState([
            'archiveRecentPlayers',
            'trackRecentPlayers',
        ]),
    },

    /**
     * Mounted hook
     */
    mounted() {
        this.getPlayers();
    },

    methods: {
        ...mapActions(['getRecentPlayers']),

        /**
         * Gets players
         *
         * @param   {*}  hash  Shows hash
         *
         */
        async getPlayers(hash = 'all') {
            this.players = [];

            if (this.playersError) {
                this.playersError = false;
            }

            if (this[`${this.itemsType}RecentPlayers`]?.[hash]) {
                this.players = [...this[`${this.itemsType}RecentPlayers`][hash]];
                return;
            }

            let url = this.apiUrls.all;

            if (hash && 'all' !== hash) {
                url = this.apiUrls.show.replace('{hash}', hash);
            }

            this.formLoading = ! this.formLoading;

            try {
                await this.getRecentPlayers({
                    url,
                    itemsType: this.itemsType,
                    itemsLimit: this.itemsLimit,
                    hash,
                });

                this.players = [...this[`${this.itemsType}RecentPlayers`][hash]];
            } catch (e) {
                this.playersError = true;
            }

            this.formLoading = ! this.formLoading;
        },
    },

};
</script>
